import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AssessmentSetToFinalService,
  GetQuestionsService,
  GetQuizQuestionsService,
  SubmitQuizService,
  SubmitSingleAnswerService,
  SubmitSingleAnswersService,
} from "../../../services/QuizService";
import { clearPosition, clearQuiz, setQuiz, setQuizComplete } from "../../../store/actions";
import ReactHtmlParser from "react-html-parser";
import DisplayQuestion from "./DisplayQuestionExam";
import Modal from "react-modal";
import Swal from "sweetalert2";
import PublicIP from "public-ip";
import Str from "../../common/Str";
import { useHistory, useParams } from "react-router-dom";
import { useMemo } from "react";
import HybridEvidences from "./HybridEvidences";
import QuizSignature from "./QuizSignature";
import { UploadTxtFile } from "../AssignmentUpload";
import { getSignatureQa, invalidateSignatureQa, mergeSignatureQa } from "../../../utils/signatureQaStorage";

function OptionList({ item, index, questionData, refresh, setrefresh }) {
  // const [opt, setopt] = useState(item.oid);
  const [option, setoption] = useState(item.oid);
  const dispatch = useDispatch();
  const onChange = (item) => {
    dispatch(setQuiz([item.qid, { ...questionData, selected: item.oid }]));
    setoption(item.oid);
    setrefresh(!refresh);
  };
  return (
    <div class="custom-control custom-radio">
      <input
        type="radio"
        // class="custom-control-input"
        id="customRadio"
        name="example"
        checked={
          parseInt(questionData.selected) == parseInt(item.oid) ? true : false
        }
        onChange={() => onChange(item)}
        value={item.oid}
      />
      <label class="custom-control-label" for="customRadio">
        {ReactHtmlParser(`${index + 1}) ${item.q_option}`)}
      </label>
    </div>
  );
}

const ViewQuestion = (props)=> {
  const dispatch = useDispatch();
  var interval = null;
  const { quiz } = useSelector((state) => state.quiz);
  const quizData = Object.values(quiz || {});
  const keys = Object.keys(quiz || {});
  const {sid} = useParams()
  // const [modalIsOpen, setIsOpen] = React.useState(false);
  const [time, settime] = useState(1);
  const [question, setquestion] = useState(0);
  const [quesno, setquesno] = useState(1);
  const [refresh, setrefresh] = useState(false);
  const [unlimited, setunlimited] = useState(false);
  const [clear, setclear] = useState(false);
  const [showmodal, setshowmodal] = useState(false);
  const [questionData, setquestionData] = useState({});
  const [quizdesc, setquizdesc] = useState({});
  const [optionData, setoptionData] = useState([]);
  const [starttime, setstarttime] = useState(0);
  const [loading, setLoading] = useState(false);
  const [attempt_no, setattempt_no] = useState(0);
  const [duration_consumed, setduration_consumed] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);
  const currentQuestion= useRef(null)
  const [isRefClick, setIsRefClick] = useState(false);
  const [signaturePage, setSignaturePage] = useState(false);
  const [sigVisited,setSigVisited] = useState(false);
  const {aid} = useParams()
  const [singleSubmitLoading, setSingleSubmitLoading] = useState([]);
  const [isLastSetToFinalNeeded,setIsLastSetToFinalNeeded] = useState(true);
  const [isHandleSubmitClicked,setIsHandleSubmitClicked] = useState(false)
  const {isAssessmentReview } = useSelector(state=>state.examLaunched);
  const [submitCalled, setSubmitCalled] = useState(false)
  const [isSignatureChanged, setIsSignatureChanged] = useState(Date.now());


  useEffect(() => {
    if(!singleSubmitLoading.length && isHandleSubmitClicked){
      handleSubmit()
    }
  },[singleSubmitLoading,isHandleSubmitClicked])

  useEffect(() => {
    if (props.isMinutePopupShown) {
      setSubmitCalled(false);
    }
  }, [props.isMinutePopupShown]);

  useEffect(() => {
    if(submitCalled){
      props.setToShowMinutePopup(false)
    }else{
      props.setToShowMinutePopup(true)
    }
  },[submitCalled])

  // Function to trigger click via ref
  const triggerClick = () => {
    setIsRefClick(true);
    currentQuestion.current.click();
  };

  useEffect(() => {
    if(quesno == quizData.length + 1){
      setSigVisited(true)
    }
  },[quesno])

  useEffect(() => {
      setSignaturePage(props?.assignmentData?.is_student_signature_required)
      props.setIsSigRequired(props?.assignmentData?.is_student_signature_required)
  },[props?.assignmentData,props?.isAssessmentReview])

  useEffect(() => {
    // console.log('FromREDUX question data is here ', quizData)
    setclear(!clear);
    if (quizData.length) {
      // if (question == 0) {
        setstarttime(new Date().valueOf());
        if(Array.isArray(quizData[0])){
          setquestion(quizData[0][0].qid);  
        } else {
          setquestion(quizData[0].qid);
        }
        setquesno(1);
        setquestionData(quizData[0]);
      // }
    }
  },[quiz]);

  function convertMinutestoSeconds(minutes) {
    return Math.floor(minutes * 60);
  }

  useEffect(() => {
    localStorage.removeItem("totaltime");
    GetQuizQuestionsService({ quid: props.quizId, assignment_id: props.aid, intake_id: sid })
      .then((res) => {
        try {
          if (!isAssessmentReview) {
            if (Object.values(res.data?.signatures || {})?.length != 0) {
              mergeSignatureQa(res.data?.signatures);
            } else {
              console.log("removed from here")
              invalidateSignatureQa();
            }
          }
        } catch (error) {
          console.log(error)
        }
        settime(res.data.description.duration);
        // props.quizTotalTime(`${res?.data?.description?.time_limit_hours || 0} hour ${res?.data?.description?.time_limit_minutes || 0} min`);

        setquizdesc(res.data.description);
        setattempt_no(parseInt(res.data.totalattempt) + 1);
        setduration_consumed(parseInt(res.data.duration_consumed));

        const obj = {};
        const allQuizId = [];
        res.data.questions.filter(list => (list && list.questions && list.questions.length > 0)).map(q => {
          if (q.type === 0) {
            obj[`qa${q.questions[0].qid}qa`] = q.questions[0]
            allQuizId.push(q.questions[0].qid);
          } else {
            obj[`qa${q.questions[0].qid}qa`] = q.questions
            allQuizId.push(q.questions.map(q => q.qid));
          }
        })
        if(!isAssessmentReview) {
          dispatch(setQuizComplete(obj))
        }
        if (res.data.description.duration != 0) {
          setunlimited(false);
          interval = setInterval(
            () =>
              settime((prevstate) =>
                prevstate != -1 ? prevstate - 1 : prevstate
              ),
            1000
          );
        } else {
          setunlimited(true);
          settime(1);
        }
      })
      .catch((err) => console.log(err));

    return () => {
      if (quizdesc.description != 0) {
        clearInterval(interval);
      }
      localStorage.removeItem("totaltime");
    };
  }, []);

  const updateQues = (question,data) => {
    dispatch(setQuiz([`qa${question?.qid}qa`,"studentEvidence",data]));
  }

  useEffect(() => {
    // localStorage.removeItem("totaltime");
    var ttimer = setInterval(() => {
      localStorage.setItem(
        "totaltime",
        parseInt(localStorage.getItem("totaltime") || 1) + 1
      );
      setrefresh(!refresh);
    }, 1000);
    return () => {
      clearInterval(ttimer);
      ttimer = null;
      localStorage.removeItem("totaltime");
      for (let i = 0; i < localStorage.length; i++) {
        let value = localStorage.key(i);
        if (value.startsWith("@")) {
          localStorage.removeItem(value);
        }
      }
    };
  }, []);

  const handleQuestion = (id) => {
    const fData = quizData.filter((item) => Array.isArray(item) ? item[0].qid == id : item.qid == id);
    setquestionData(fData[0]);
  };

  const onChange = (oid = []) => {
    dispatch(
      setQuiz([question, { ...questionData, selected: oid, choice: [] }])
    );
    setclear(!clear);
  };

  function fancyTimeFormat(duration) {
    // Hours, minutes and seconds
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;

    var ret = "";

    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    // props.currentTimeStatus(hrs, mins, secs)
    return ret;
  }

  const submitQuiz = () => {
    setquizdesc({ ...quizdesc, duration: 0 });
    // settime(-2);
    handleSubmit('timeup');
    // props.setshow({ review: true });
  };

  const handleSubmit = async (section = '') => {
    if (singleSubmitLoading.length && section != 'unanswerStatus') {
      setIsHandleSubmitClicked(true)
      return;
    }
    // settime(-2);
    try {
      setLoading(true);

      const score_individual = [];
      const total_score_individual = [];
      const individual_time = [];
      const individual_time_db = [];
      let quizanswer = [];
      let qid = [];
      props.updateSubmitQuizAssessment();
      for (let i = 0; i < localStorage.length; i++) {
        let value = localStorage.key(i);
        if (value.startsWith("@qa")) {
          // console.log(value);
          // const key = value.substr(1);
          const key = value.replace("@qa", "").replace("qa", "");
          const score = quizData.filter((data) => Array.isArray(data) ? data.filter(d => d.qid == key) : data.qid == key);
          let scoreTemp = 0;
          if (score.length > 0) {
            scoreTemp = score[0].score;
          }
          individual_time.push({
            key,
            time: localStorage.getItem(value),
            score: scoreTemp,
          });
        }
      }

      const getAnswerItem = (item) => {
        // console.log("item.question_type>>>>>>>>>>>>", item.question_type)
        const answerItemList = []
        if (item.question_type == "Multiple Choice Single Answer") {
          if (
            item.selected != "" &&
            item.selected != [] &&
            item.selected != null
          ) {
            answerItemList.push({
              aid: 0,
              oid: item.selected,
              qid: item.qid,
              q_option: item.selected,
              // score: item.score,
              docs: null,
            });
          }
        }

        // Multiple Choice Multiple Answer
        if (item.question_type == "Multiple Choice Multiple Answer") {
          item && item?.selected && item?.selected?.length && item.selected.map((data) => {
            if (
              item.selected != "" &&
              item.selected != [] &&
              item.selected != null
            ) {
              if (data != "" && data != null) {
                answerItemList.push({
                  aid: 0,
                  oid: data,
                  qid: item.qid,
                  q_option: data,
                  // score: item.score,
                  docs: null,
                });
              }
            }
          });
        }

        // Match the Column
        if (item.question_type == "Match the Column") {
          // console.log("itemssssss->",item);
          item.choice.map((data, itr) => {
            if (data != "" && data != [] && data != null) {
              answerItemList.push({
                aid: 0,
                oid: item.options[itr].oid,
                qid: item.qid,
                q_option: data,
                // score: item.scoreArr[itr],
                docs: null,
              });
            }
          });
        }

        // Short Answer
        if (item.question_type == "Short Answer") {
          if (
            item.selected != "" &&
            item.selected != [] &&
            item.selected != null
          ) {
            answerItemList.push({
              aid: 0,
              qid: item.qid,
              q_option: (Array.isArray(item?.selected) && item?.selected.length) ? item?.selected[0]?.q_option.toString().trim() : item.selected.toString().trim(),
              // score: item.score,
              docs: null,
            });
          }
        }

        // Long Answer
        if (item.question_type == "Long Answer") {
          if (
            item.selected != "" &&
            item.selected != [] &&
            item.selected != null
          ) {
            answerItemList.push({
              aid: 0,
              qid: item.qid,
              q_option: (Array.isArray(item?.selected) && item?.selected.length) ? item?.selected[0]?.q_option.toString().trim() : item.selected.toString().trim(),
              // score: item.score,
              docs: null,
            });
          }
        }

        // order list
        if (item.question_type == "Order List") {
          item.choice.map((data, ind) => {
            if (data !== "" && (data.length != 0) && data !== null) {
              answerItemList.push({
                aid: 0,
                oid: item.selected[ind],
                qid: item.qid,
                q_option: `${data.replace("___", "")}___${item?.selectedItems[ind]}`,
                // score: item.scoreArr[ind],
                docs: null,
              });
            }
          })
        }

        // Fill In The Blank
        if (item.question_type == "Fill in the blank") {
          // console.log("itemssssss->",item);
          item.selected.map((data) => {
            if (data != "" && data != [] && data != null) {
              answerItemList.push({
                aid: 0,
                oid: data.oid,
                qid: item.qid,
                q_option: JSON.stringify([data.q_option_match.trim()]),
                // score: data.score,
                docs: null,
              });
            }
          })
        }

        // Choice Matrix
        if (item.question_type == "Choice Matrix") {
          item.selected.map((data) => {
            if (data != "" && data != [] && data != null) {
              // Get scores from options array
              const option = item.options.find(opt => opt.oid === data.oid);
              const optionData = option ? JSON.parse(option.q_option) : [];

              // Add missing scores to q_option
              const qOptionWithScores = data.q_option.map(qOpt => ({
                ...qOpt,
                score: qOpt.score || optionData.find(opt => opt.titleValue === qOpt.titleValue)?.score || 0
              }));

              // Add missing score to q_option_match
              const qOptionMatch = {
                ...data.q_option_match,
                score: data.q_option_match.score || optionData.find(opt => opt.titleValue === data.q_option_match.titleValue)?.score || 0
              };
              let answerObj = {
                aid: 0,
                oid: data.oid,
                qid: item.qid,
                q_option: `${JSON.stringify(qOptionWithScores).replace('___', '')}___${JSON.stringify([qOptionMatch])}`,
                docs: null,
              }
              answerItemList.push(answerObj);
            }
          });
        }

        // Document Upload
        if (item.question_type === "Document Upload") {
          // console.log("document upload item->",item);
          if (item?.selected) {
            item.selected.map((d) => {
              answerItemList.push({
                aid: 0,
                qid: item.qid,
                docs: d,
              });
            })
          }
        }
        if (item.question_type === "Evidence Only" && Array.isArray(item.studentEvidence)) {
          const doc = {
            evidence_photo: null,
            evidence_video: null,
          };

          item.studentEvidence.forEach((d) => {
            if (d.evidence_type === 0) {
              doc.evidence_photo = d.evidence_url;
            } else if (d.evidence_type === 1) {
              doc.evidence_video = d.evidence_url;
            }
          });

          if (doc.evidence_photo || doc.evidence_video) {
            answerItemList.push({
              aid: 0,
              qid: item.qid,
              docs: doc,
            });
          }
        }

        return answerItemList;
      };

      quizData.map((item) => {

        // Multiple Choice Single Answer
        if (item.question_type) {
          quizanswer = [...quizanswer, ...getAnswerItem(item)]
          // quizanswer.push(...getAnswerItem(item))
          qid.push(item.qid);
        } else if (Array.isArray(item) && item.length) {
          item.map((subItem) => {
            quizanswer = [...quizanswer, ...getAnswerItem(subItem)]
            qid.push(subItem.qid);
          })
        }
      });

      individual_time.sort(function (a, b) {
        return a.key - b.key;
      });

      individual_time.map((item) => {
        // qid.push(item.key);
        // score_individual.push(item.score);
        individual_time_db.push(item.time);
      });

      qid.map(q => {
        quizData.map(qd => {
          if (Number(q) === qd?.qid) {
            total_score_individual.push(qd.correct_score)
            score_individual.push(qd.score)
          } else if (Array.isArray(qd)) {
            qd.map(subQd => {
              if (Number(q) === subQd.qid) {
                total_score_individual.push(subQd.correct_score)
                score_individual.push(subQd.score)
              }
            })
          }
        })
      })


      const percentage = score_individual.reduce((acc, item, ind) => acc + item, 0);

      const maxMarks = quizData.reduce((acc, item, index) => Array.isArray(item) ? acc + item.reduce((a, v, i) => a + v.correct_score, 0) : acc + item.correct_score, 0);

      if (section == 'unanswerStatus') {
        // evidence popup
        const checkEvidence = checkDisableCondition();
        if (checkEvidence.disabled) {
          const questionNumbers = checkEvidence.missingItems.map(item => item.missingAt);
          const formattedNumbers = questionNumbers.length > 1
            ? `${questionNumbers.slice(0, -1).join(', ')} & ${questionNumbers[questionNumbers.length - 1]}`
            : questionNumbers[0];

          Swal.fire({
            title: "Missing Evidence",
            html: `<span style="display: flex; flex-wrap: wrap;">Please Upload Required Document for Question - ${formattedNumbers}</span>`,
            icon: "error",
            confirmButtonText: "Ok"
          });
          setSubmitLoading(false);
          setLoading(false);
          return;
        }

        let setFinalStr = false

        const answeredQues = quizanswer.map((ans) => (ans.qid));
        const uniqueAnseweredQues = [...new Set(answeredQues)]
        if (uniqueAnseweredQues.length === qid.length) {
          setFinalStr = true;
        }
        setToFinal(setFinalStr ? '' : '<p><span style="color:#e74c3c">You have unanswered questions</span></p>');
        setSubmitLoading(false);
        setLoading(false);
        return;
      }


      // check hybrid question
      let isHybrid = false;
      const hybridTypeQues = ["Long Answer", "Document Upload"];
      for (let q = 0; q < quizData.length; q++) {
        const question = Array.isArray(quizData[q]) ? quizData[q] : [quizData[q]];
        for (let inQ = 0; inQ < question.length; inQ++) {
          if (hybridTypeQues.includes(question[inQ].question_type)) {
            isHybrid = true;
            break;
          }
        }
        if (isHybrid) {
          break;
        }
      }
      props.setIsExamLaunchedToFalse();
      const body = {
        quid: props.quizId,
        totaltime:
          parseInt(localStorage.getItem("totaltime")) + duration_consumed ? parseInt(localStorage.getItem("totaltime")) + duration_consumed : 0,
        individual_time_db: individual_time_db.join(),
        user_type: "student",
        starttime: starttime,
        endtime: new Date().valueOf(),
        publicip: await PublicIP.v4(),
        quizanswer,
        r_qids: qid.join(),
        assessment_id: props.aid,
        hybrid: isHybrid ? 1 : 0,
        autoSubmit: section == 'timeup' ? 1 : 0,
        intake: sid,
        ...props.autoSubmitDetails
      };
      try {
        if (submitCalled) {
          return;
        }
        setSubmitCalled(true);
        setSubmitLoading(true);
        await handleSaveAndNext(Array.isArray(quizData[quizData.length - 1]) ? quizData[quizData.length - 1].map(d => d.qid) : [quizData[quizData.length - 1]?.qid]);
        try {
          const resUploadTxtFile = await UploadTxtFile({ id: props.aid });

          if (resUploadTxtFile.fileKey && resUploadTxtFile.size) {
            body['fileKey'] = resUploadTxtFile.fileKey;
            body['size'] = resUploadTxtFile.size;
          }

          const resAssessmentFinalService = await AssessmentSetToFinalService(body);

          setSubmitCalled(false);
          Swal.close();
          props.stop(true);
          dispatch(clearPosition());

          try {
            let localData = localStorage.getItem('Monitoring Object' + props?.aid)
            if (localData) {
              localStorage.removeItem('Monitoring Object' + props?.aid)
            }
          } catch (err) {
            console.log(err)
          }

          if (resAssessmentFinalService.data.status) {
            localStorage.removeItem("totaltime");

            for (let i = 0; i < localStorage.length; i++) {
              let value = localStorage.key(i);
              if (value.startsWith("@")) {
                localStorage.removeItem(value);
              }
            }

            for (let i = 0; i < localStorage.length; i++) {
              let value = localStorage.key(i);
              if (value.startsWith("@")) {
                localStorage.removeItem(value);
              }
            }

            localStorage.removeItem("totaltime");

            Swal.fire({
              icon: "success",
              title: "Quiz Submitted",
              timer: 1000
            });

            props.setrId(resAssessmentFinalService.data.rid);
            props.setshow({ review: true });
            props.initiateReload();
            props.getSubContentMethod();
            props.updateSubjectOnly();
          }

        } catch (err) {
          Swal.close();
          console.log(err);
          setSubmitCalled(false);

          if (err?.response?.status == 400 && err?.response?.data?.alreadySubmitted == true) {
            Swal.fire({
              icon: "info",
              title: "Assessment already submitted",
              text: err.response.data.message,
            }).then(() => {
              props.initiateReload();
            })
          } else {
            Swal.fire({
              icon: "error",
              title: "Submission Interrupted",
              text: 'Please check your internet connection and try again.',
              confirmButtonText: "Retry",
              confirmButtonColor: "#3085d6",
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              backdrop: true,
            }).then((retryResult) => {
              if (retryResult.isConfirmed) {
                if (props.submitQuizAssessment) {
                  popupQue1()
                } else {
                  handleSubmit('unanswerStatus')
                }
              }
            })
          }
        }
      } catch (err) {
        Swal.close();
        console.log(err);
        setSubmitLoading(false);
        if (err?.response && err?.response?.status == 400 && err?.response?.data?.alreadySubmitted == true) {
          Swal.fire({
            icon: "info",
            title: "Assessment already submitted",
            text: err.response.data.message,
          }).then(() => {
            props.initiateReload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Submission Interrupted",
            text: 'Please check your internet connection and try again.',
            confirmButtonText: "Retry",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
          }).then((res) => {
            if (res.isConfirmed) {
              if (props.submitQuizAssessment) {
                popupQue1()
              } else {
                handleSubmit('unanswerStatus')
              }
            }
          })
        }
      } finally {
        setSubmitCalled(false);
      }
    } catch (err) {
      setSubmitLoading(false)
      setSubmitCalled(false)
      Swal.fire({
        icon: "error",
        title: "Submission Interrupted",
        text: 'Please check your internet connection and try again.',
        confirmButtonText: "Retry",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((res) => {
        if (res.isConfirmed) {
          if (props.submitQuizAssessment) {
            popupQue1()
          } else {
            handleSubmit('unanswerStatus')
          }
        }
      })
    } finally {
      setSubmitLoading(false);
      setSubmitCalled(false);
      setLoading(false);
    }
  };

  const popupQue1 = () => {
    if (props?.submitQuizAssessment && !submitCalled) {
      // console.log("___________________ view ques 1")
      Swal.fire({
        title: props.canBeSTF ? 'Loading' : "Times Up!",
        text: "",
        // timer: 20000,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        backdrop: true,
        onOpen: function () {
          Swal.showLoading();
        },
      })
      handleSubmit('timeup');
    }
  }
  useEffect(()=>{
    // console.log("___________________ view ques 1",props?.submitQuizAssessment);
    popupQue1()
  },[props?.submitQuizAssessment,props.canBeSTF])

  const handleSaveAndNext = (qid, toWait = true) => {
    if(props?.isAssessmentReview || (qid.length == 1 && (qid[0] == null || qid[0] == 'null'))){
      return
    }
    let quizanswer = [];
    let timearr = [];
 

    const getAnswerItem = (item) =>{
      const answerItemList = []
      // Multiple Choice Multiple Answer && Multiple Choice Single Answer && Choice Matrix && Fill In The Blank && Document Upload
      if (item.question_type == "Multiple Choice Single Answer" || item.question_type == "Multiple Choice Multiple Answer" || item.question_type == "Choice Matrix" || item.question_type == "Fill in the blank" || item.question_type === "Document Upload" || item.question_type === "Evidence Only") {
        answerItemList.push({
          aid: 0,
          qid: item.qid,
          q_option: item.selected,
          docs: null,
          type: item.question_type,
        });
      }
  
      // Match the Column && Order List
      if (item.question_type == "Match the Column" || item.question_type == "Order List") {
        answerItemList.push({
          aid: 0,
          qid: item.qid,
          q_option: {choice: item.choice, selectedItems: item.selectedItems, selected: item.selected},
          docs: null,
          type: item.question_type,
        });
      } 
  
      // Long Answer && Short Answer
      if (item.question_type == "Long Answer" || item.question_type == "Short Answer") {
        answerItemList.push({
          aid: 0,
          qid: item.qid,
          q_option: (Array.isArray(item?.selected) && item?.selected.length) ? item?.selected[0]?.q_option.toString().trim() : item.selected.toString().trim(),
          docs: null,
          type: item.question_type,
        });
      }
  
      return answerItemList;
    }
    quizData.map((item) => {
      if(item.question_type){
        quizanswer = [...quizanswer, ...getAnswerItem(item)]
        timearr.push(localStorage.getItem(`@qa${item?.qid}qa`));
      }else if(Array.isArray(item) && item.length){
        item.map((subItem)=>{
          quizanswer = [...quizanswer, ...getAnswerItem(subItem)]
          timearr.push(localStorage.getItem(`@qa${subItem?.qid}qa`));
        })
      }
    });

    quizanswer = quizanswer.filter(d => qid.includes(d.qid))
    let body = {
      assessment_id: Number(props.aid),
      attempt_no,
      quizanswer,
      quid: props.quizId,
      duration: time,
      individual_time: timearr.join(),
      duration_consumed:
        parseInt(localStorage.getItem("totaltime")) + duration_consumed,
      qid : qid
    };

    if(toWait){
      setSingleSubmitLoading(prev => [...prev, ...qid]);
    } 
   
  return SubmitSingleAnswersService(body)
  .then((res) => {
    setSingleSubmitLoading(prevValue => prevValue?.filter(d => !qid.includes(d)))
    return res;
  })
  .catch((error) => {
    setSingleSubmitLoading(prevValue => prevValue?.filter(d => !qid.includes(d)))
    if(error.response && error.response.status==400 && error?.response?.data?.alreadySubmitted==true){
      Swal.fire({
        icon: "info",
        title: "Assessment already submitted",
        text: error.response.data.message,
      }).then(()=>{
        props.initiateReload();
      })
    }
    throw error; 
  });
  };                                                    


  const AutoSubmitModal = () => {
    return (
      <div className="card card-header-transparent card-header-transparent-no-padding mb-3">
        <div className="card-body">
          <div className="card card-quiz card-header-dark">
            <div className="card-header">Submit Quiz</div>
            <div className="card-body">
              <div className="form-group">
                <label className="d-block mb-3">
                  <strong>Are you sure you want to submit this quiz?</strong>
                </label>
              </div>
            </div>
          </div>

          <div className="quiz-footer-btns mt-4">
            <button
              onClick={()=>{handleSubmit()}}
              className="btn btn-white-bordered btn-primary"
              disabled={loading}
            >
              {loading ? (
                <i className="fas fa-cog fa-spin"></i>
              ) : (
                <i className="fal fa-check"></i>
              )}
              Submit Quiz
            </button>

            <button
              onClick={() => setshowmodal(false)}
              className="btn btn-danger"
              disabled={loading}
            >
              <i className="fal fa-times"></i>Cancel
            </button>
          </div>
        </div>
      </div>
    );
  };
  
  if (time == 0 && props?.submitQuizAssessment && !submitCalled) {
    if (quizdesc.description != 0) {
      clearInterval(interval);
    }
    Swal.fire({
      icon: "success",
      title: "Quiz Submitted",
    }).then(() => {
      submitQuiz();
    });
  }

  const isShowing = (index) => {
    if (quizData.length <= 10) {
      return ''
    }
    else if (quesno > 4 && quesno < quizData.length - 5) {
      if (inRange(index, quesno - 4, quesno + 5)) {
        return ''
      }
      else {
        return 'd-none'
      }
    }
    else if (quesno <= 4) {
      if (inRange(index, 0, 9)) {
        return
      }
      else {
        return 'd-none'
      }
    }
    else if (quesno >= quizData.length - 5) {
      if (inRange(index, quizData.length - 10, quizData.length)) {
        return
      }
      else {
        return 'd-none'
      }
    }
  }

  function inRange(x, min, max) {
    return ((x - min) * (x - max) <= 0);
  }

  const handleReviewQuest=(nextNav)=>{
    if (nextNav == 'next' && (signaturePage ? quesno != (quizData.length) + 1 : quesno != (quizData.length))) {
    setquesno(quesno + 1);
    setquestion(Array.isArray(quizData[quesno]) ? quizData[quesno][0].qid : quizData[quesno].qid);
    handleQuestion(Array.isArray(quizData[quesno]) ? quizData[quesno][0].qid : quizData[quesno].qid);
  } else if (nextNav == 'back' && quesno != 1) {
    setquesno(quesno - 1)
    setquestion(Array.isArray(quizData[quesno - 2]) ? quizData[quesno - 2][0].qid : quizData[quesno - 2].qid);
    handleQuestion(Array.isArray(quizData[quesno - 2]) ? quizData[quesno - 2][0].qid : quizData[quesno - 2].qid);

  } else if (nextNav == 'last' && (signaturePage ? quesno != (quizData.length) + 1 : quesno != (quizData.length))) {
    signaturePage ? setquesno(quizData.length + 1) : setquesno(quizData.length);
    setquestion(Array.isArray(quizData[quizData.length - 1]) ? quizData[quizData.length - 1][0].qid : quizData[quizData.length - 1].qid);
    handleQuestion(Array.isArray(quizData[quizData.length - 1]) ? quizData[quizData.length - 1][0].qid : quizData[quizData.length - 1].qid);
  }else if (nextNav == 'first' && quesno != 1) {
    setquesno(1);
    setquestion(Array.isArray(quizData[0]) ? quizData[0][0].qid : quizData[0].qid);
    handleQuestion(Array.isArray(quizData[0]) ? quizData[0][0].qid : quizData[0].qid);
  }
}
  const handleNav = (nextNav) => {
    if (nextNav == 'next' && (signaturePage ? quesno != (quizData.length) + 1 : quesno != (quizData.length))) {
      setquesno(quesno + 1);
      localStorage.setItem(
        Array.isArray(quizData[quesno]) ? `@qa${quizData[quesno][0]?.qid}qa` : `@qa${quizData[quesno]?.qid}qa`,
        parseInt(localStorage.getItem(Array.isArray(quizData[quesno]) ? `@qa${quizData[quesno][0]?.qid}qa` : `@qa${quizData[quesno]?.qid}qa`) || 0) + 1
      );
      setquestion(Array.isArray(quizData[quesno]) ? quizData[quesno][0]?.qid : quizData[quesno]?.qid);
      handleQuestion(Array.isArray(quizData[quesno]) ? quizData[quesno][0]?.qid : quizData[quesno]?.qid);
      handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid]);
    }
    else if (nextNav == 'back' && quesno != 1) {
      // console.log('the ques and quizData is ', quesno, quizData, quizData.length)
      setquesno(quesno - 1)
      localStorage.setItem(
        Array.isArray(quizData[quesno - 2]) ? `@qa${quizData[quesno - 2][0]?.qid}qa` : `@qa${quizData[quesno - 2]?.qid}qa`,
        parseInt(localStorage.getItem(Array.isArray(quizData[quesno - 2]) ? `@qa${quizData[quesno - 2][0]?.qid}qa` : `@qa${quizData[quesno - 2]?.qid}qa`) || 0) + 1
      );
      setquestion(Array.isArray(quizData[quesno - 2]) ? quizData[quesno - 2][0]?.qid : quizData[quesno - 2]?.qid);
      handleQuestion(Array.isArray(quizData[quesno - 2]) ? quizData[quesno - 2][0]?.qid : quizData[quesno - 2]?.qid);
      handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid]);
    }
    else if (nextNav == 'last' && (signaturePage ? quesno != (quizData.length) + 1 : quesno != (quizData.length))) {
      signaturePage ? setquesno(quizData.length + 1) : setquesno(quizData.length);
      if(!signaturePage){
        localStorage.setItem(
          Array.isArray(quizData[quizData.length - 1]) ? `@qa${quizData[quizData.length - 1][0]?.qid}qa` : `@qa${quizData[quizData.length - 1]?.qid}qa`,
          parseInt(localStorage.getItem(Array.isArray(quizData[quizData.length - 1]) ? `@qa${quizData[quizData.length - 1][0]?.qid}qa` : `@qa${quizData[quizData.length - 1]?.qid}qa`) || 0) + 1
        );
      }
      setquestion(Array.isArray(quizData[quizData.length - 1]) ? quizData[quizData.length - 1][0]?.qid : quizData[quizData.length - 1]?.qid);
      handleQuestion(Array.isArray(quizData[quizData.length - 1]) ? quizData[quizData.length - 1][0]?.qid : quizData[quizData.length - 1]?.qid);
      handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid]);
    }
    else if (nextNav == 'first' && quesno != 1) {
      setquesno(1)
      localStorage.setItem(
        Array.isArray(quizData[0]) ? `@qa${quizData[0][0]?.qid}qa` : `@qa${quizData[0]?.qid}qa`,
        parseInt(localStorage.getItem(Array.isArray(quizData[0]) ? `@qa${quizData[0][0]?.qid}qa` : `@qa${quizData[0]?.qid}qa`) || 0) + 1
      );
      setquestion(Array.isArray(quizData[0]) ? quizData[0][0]?.qid : quizData[0]?.qid);
      handleQuestion(Array.isArray(quizData[0]) ? quizData[0][0]?.qid : quizData[0]?.qid);
      handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid]);
    }
  }

  const setToFinal = (str) => {
    Swal.close();
    Swal.fire({
      title: 'Are you sure?',
      html: `${Str.setFinalPopup} ${str}`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: Str.Submit,

    }).then(function (result) {
      if (result.value) {
        handleSubmit('')
        Swal.fire({
          title: "Loading",
          text: "",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          backdrop: true,
          onOpen: function () {
            Swal.showLoading();
          },
        }).then((result) => {
          if(result.dismiss == Swal.DismissReason.timer){
            Swal.fire({
              icon: "error",
              title: "Please retry",
              text: "The operation took longer than expected. Would you like to retry?",
              showCancelButton: true,
              confirmButtonText: "Retry",
              cancelButtonText: "Cancel",
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
            }).then((retryResult) => {
              if(retryResult.isConfirmed){
                handleSubmit('unanswerStatus')
              }
            })
          }
        })
        setSubmitLoading(false);

      }else{
        setSubmitLoading(false);
      }
    });
  }


  const checkDisableCondition = useCallback(() => {
    const missingItems = [];
  
    for (let index = 0; index < quizData.length; index++) {
      const data = quizData[index];
      const hasPhoto = data?.evidence_photo;
      const hasVideo = data?.evidence_video;
      const studentEvidence = data?.studentEvidence || [];
  
      const hasPhotoEvidence = studentEvidence.some(d => d.evidence_type == 0);
      const hasVideoEvidence = studentEvidence.some(d => d.evidence_type == 1);
  
      let missingType = '';
  
      if (hasPhoto && hasVideo) {
        if (!hasPhotoEvidence && !hasVideoEvidence) {
          missingType = 'both';
        } else if (!hasPhotoEvidence) {
          missingType = 'photo';
        } else if (!hasVideoEvidence) {
          missingType = 'video';
        }
      } else if (hasPhoto && !hasPhotoEvidence) {
        missingType = 'photo';
      } else if (hasVideo && !hasVideoEvidence) {
        missingType = 'video';
      }
  
      if (missingType) {
        missingItems.push({
          missingAt: index + 1,
          missingType
        });
      }
    }
  
    return {
      disabled: missingItems.length > 0,
      missingItems
    };
  }, [quizData]);  
  

  const renderQuesType = (type) => {
    switch (type) {
      case "Multiple Choice Single Answer":
        return <span className="ques__type">Single Choice <i className="fal fa-tasks"></i></span>;
      case "Multiple Choice Multiple Answer":
        return <span className="ques__type">Multiple Choice <i className="far fa-check-square"></i></span>;
      case "Match the Column":
        return <span className="ques__type">Match The Column <i className="far fa-line-columns"></i></span>;
      case "Short Answer":
        return <span className="ques__type">Short Answer <i className="far fa-comment-alt-lines"></i></span>;
      case "Long Answer":
        return <span className="ques__type">Long Answer <i className="fal fa-align-left"></i></span>;
      case "Fill in the blank":
        return <span className="ques__type">Fill In The Blanks <i className="far fa-keyboard"></i></span>;
      case "Order List":
        return <span className="ques__type">Order List <i className="fas fa-sort-numeric-down"></i></span>;
      case "Choice Matrix":
        return <span className="ques__type">Choice Matrix <i className="fal fa-table"></i></span>;
      case "Document Upload":
        return <span className="ques__type">Document Upload <i className="fal fa-file-upload"></i></span>;
      case "Signature":
        return <span className="ques__type">Student Signature <i className="fal fa-signature"></i></span>;
      default:
        return
    }
  }

  const checkLocalstorageKeys = (item) => {
    let isZero = 0;
    if (Array.isArray(item)) {
      for (let i = 0; i < item.length; i++) {
        if (!localStorage.getItem(`@qa${item[i].qid}qa`) || localStorage.getItem(`@qa${item[i].qid}qa`)==null || localStorage.getItem(`@qa${item[i].qid}qa`) == 0) {
          isZero = 0;
        } else {
          isZero = 1;
          break;
        }
      }
    } else {
      isZero = (!localStorage.getItem(`@qa${item.qid}qa`) || localStorage.getItem(`@qa${item.qid}qa`)==null || localStorage.getItem(`@qa${item.qid}qa`) == 0) ? 0 : 1;
    }
    return isZero;
  }

  const isSelectedAnswer = (item) => {
    let isSelected = false;
    if (Array.isArray(item)) {
      for (let i = 0; i < item.length; i++) {
        // console.log("___________________ selected ______", item[i].selected);
        if (item[i]?.selected?.length > 0 && item[i]?.selected !== "" && item[i].selected !== undefined && item[i].selected !== null) {
          isSelected = true;
          break;
        } else {
          isSelected = false;
        }
      }
    } else if (item.question_type === "Long Answer" || item.question_type === "Short Answer") {
      const hasPhotoEvidence = item?.studentEvidence?.some(d => d?.evidence_type == 0);
      const hasVideoEvidence = item?.studentEvidence?.some(d => d?.evidence_type == 1);
      const hasValidSelection = (item?.selected?.length > 0 && (Array.isArray(item?.selected) ? item?.selected?.some(d => d?.q_option != "") : 1 == 1) && item?.selected !== "" && item?.selected !== undefined && item?.selected !== null) ? true : false;

      if (item.evidence_photo && item.evidence_video) {
        isSelected = hasPhotoEvidence && hasVideoEvidence && hasValidSelection;
      } else if (item.evidence_photo) {
        isSelected =  hasPhotoEvidence && hasValidSelection;
      } else if (item.evidence_video) {
        isSelected = hasVideoEvidence && hasValidSelection;
      } else {
        isSelected = hasValidSelection;
      }
    } else if(item.question_type == "Evidence Only"){
      isSelected = ((item?.evidence_photo && !item?.evidence_video) && item?.studentEvidence?.find(d => d?.evidence_type == 0)) || 
                   ((item?.evidence_video && !item?.evidence_photo) && item?.studentEvidence?.find(d => d?.evidence_type == 1)) || 
                   ((item?.evidence_photo && item?.evidence_video) && item?.studentEvidence?.find(d => d.evidence_type == 0) && item?.studentEvidence?.find(d => d.evidence_type == 1))
    } else if (item?.evidence_photo || item?.evidence_video) {
      if (item?.evidence_photo && item?.evidence_video){
        isSelected = item?.studentEvidence?.find(d => d.evidence_type == 0) && item?.studentEvidence?.find(d => d.evidence_type == 1) && (item?.selected?.length > 0 && item?.selected!== "" && item?.selected!== undefined && item?.selected!== null)? true : false;
      }else if(item?.evidence_photo) {
        isSelected = item?.studentEvidence?.find(d => d?.evidence_type == 0) && (item?.selected?.length > 0 && item?.selected !== "" && item?.selected !== undefined && item?.selected !== null) ? true : false;
      } else if (item?.evidence_video) {
        isSelected = item?.studentEvidence?.find(d => d?.evidence_type == 1) && (item?.selected?.length > 0 && item?.selected !== "" && item?.selected !== undefined && item?.selected !== null) ? true : false;
      }
    }
    else {
      isSelected = (item?.selected?.length > 0 && item?.selected !== "" && item?.selected !== undefined && item?.selected !== null) ? true : false;
    }
    return isSelected;
  }

  useEffect(() => {
    if(props?.sigPoped){
      setquesno(quizData.length + 1)
    }
  }, [props?.sigPoped]);

  const {
    isValidSignature,
    isGreen
  } = useMemo(() => {
    const raw = getSignatureQa();

    let parsed = null;
    try {
      parsed = raw ? JSON.parse(raw) : null;
    } catch {
      parsed = null;
    }

    const hasSignature =
      parsed?.signature !== "" &&
      parsed?.signature !== "null";

    const isValidSignature =
      parsed &&
      parsed?.assessment_id == aid &&
      parsed?.attempted_no == attempt_no &&
      hasSignature &&
      parsed?.is_terms_checked;

    return {
      isValidSignature,
      isGreen: hasSignature && parsed?.is_terms_checked
    };
  }, [aid, attempt_no, getSignatureQa()]);

  return (
    <div class="card card-header-transparent">
        <>
          <div class="">
            <div class="row align-items-center d-none">
              <div class="col-md-4">
                {unlimited ? (
                  <></>
                ) : (
                  <div class="quicz-time">
                    Time Left: <strong>{fancyTimeFormat(time)}</strong>
                  </div>
                )}
              </div>
              <div class="col-md-8 text-right">
              </div>
            </div>
            {/* Question Group */}
            {questionData && Object.keys(questionData).length ? Array.isArray(questionData) ? (
              <div class="card card-quiz card-header-dark">
                {
                  quesno > quizData.length ? 
                  <>
                    <div class="card-header">Student Declaration {renderQuesType("Signature")}</div>
                    <div className="card-body">
                      <QuizSignature setIsSignatureChanged={setIsSignatureChanged} isSignatureChanged={isSignatureChanged} assignmentData={props.assignmentData} attempt={attempt_no} link={props?.assignmentData?.linkTandC} isAssessmentReview={props?.isAssessmentReview}/>
                    </div>
                  </> 
                  : 
                  <>
                    <div class="card-header">{questionData[0]?.group_name}</div>
                    <div class="card-body">
                      {questionData.map((q, i) => (
                        <div key={i} className={(questionData.length - 1) === i ? "" : "mb-4"}>
                          <DisplayQuestion
                            assignmentData={props.assignmentData}
                            grpId={questionData[0].qid}
                            qInd={i}
                            question={q}
                            setquestion={setquestionData}
                            refresh={refresh}
                            setrefresh={setrefresh}
                            // quesno={quesno}
                            clear={clear}
                            showQuesType={renderQuesType(q?.question_type)}
                            isAssessmentReview={props?.isAssessmentReview}
                            triggerClick={triggerClick}
                          />
                          {isAssessmentReview && Array.isArray(q?.observationFeedback) &&
                            typeof q?.observationFeedback[0] === 'object' && q?.observationFeedback[0]?.user_feedback ? <div className={`${!q?.evidence_photo && !q?.evidence_video ? "mt-4" : ""}`}>
                            <div className="quiz-feedback d-block">
                              <p className="quiz-feedback-title mb-2">Feedback</p>
                              <div className="quiz-feedback-content">{q?.observationFeedback[0]?.user_feedback}</div>
                            </div>
                          {i !== questionData.length - 1 ? <hr /> : null}
                          </div> : null}
                        </div>
                      ))}
                    </div>
                  </>
                }
                </div>
            ) :
              (<div class="card card-quiz card-header-dark">
                {
                  quesno > quizData.length ? 
                  <>
                    <div class="card-header">Student Declaration {renderQuesType("Signature")}</div>
                    <div className="card-body">
                      <QuizSignature setIsSignatureChanged={setIsSignatureChanged} isSignatureChanged={isSignatureChanged} assignmentData={props.assignmentData} attempt={attempt_no} link={props?.assignmentData?.linkTandC} isAssessmentReview={props?.isAssessmentReview}/>
                    </div>
                  </>
                  :
                  <>
                    <div class="card-header">Question {quesno} {renderQuesType(questionData?.question_type)}</div>
                    <div class="card-body">
                      <DisplayQuestion
                        assignmentData={props.assignmentData}
                        question={questionData}
                        setquestion={setquestionData}
                        refresh={refresh}
                        setrefresh={setrefresh}
                        quesno={quesno}
                        clear={clear}
                        isAssessmentReview={props?.isAssessmentReview}
                        triggerClick={triggerClick}
                      />
                      <HybridEvidences assignmentData={props?.assignmentData} question={questionData} attempt={attempt_no} updateQues={updateQues} isAssessmentReview={props?.isAssessmentReview}/>

                      {isAssessmentReview && Array.isArray(questionData?.observationFeedback) &&
                        typeof questionData?.observationFeedback[0] === 'object' && questionData?.observationFeedback[0]?.user_feedback ? <div className={`${!questionData?.evidence_photo && !questionData?.evidence_video ? "mt-4" : ""}`}>
                        <div className="quiz-feedback d-block">
                          <p className="quiz-feedback-title mb-2">Feedback</p>
                          <div className="quiz-feedback-content">{questionData?.observationFeedback[0]?.user_feedback}</div>
                        </div>
                      </div> :null}
                      
                    </div>
                  </>
                }
              </div>)
            : quesno > quizData.length && signaturePage ?
              <>
                <div class="card card-quiz card-header-dark">
                  <div class="card-header">Student Declaration {renderQuesType("Signature")}</div>
                  <div className="card-body">
                    <QuizSignature setIsSignatureChanged={setIsSignatureChanged} isSignatureChanged={isSignatureChanged} assignmentData={props.assignmentData} attempt={attempt_no} link={props?.assignmentData?.linkTandC} isAssessmentReview={props?.isAssessmentReview}/>
                  </div>
                </div>
              </> : null
            }
            
            <ul className="quiz-info">
              <li className="Unanswered-quiz">Unanswered</li>
              <li className="answered-quiz">Answered</li>
              <li className="non-visited">Not-visited</li>
            </ul>
            {
             !props?.sigPoped ? (
            <div className="pagination-btn-group d-flex justify-content-between mt-4 mb-4">

              <ul class="quiz-pagination d-flex">

                <li
                  class={"page-item action-pagination " + (quesno != 1 ? '' : 'disabled')}
                  onClick={() => { isAssessmentReview ? handleReviewQuest('first') : handleNav('first') }}
                >

                  <a class={"page-link pre-page-link "}>
                    <i class="fas fa-angle-double-left"></i>
                  </a>
                </li>
                <li
                  onClick={() => { isAssessmentReview ? handleReviewQuest('back') : handleNav('back') }}
                  class={"page-item action-pagination pre-step-link " + (quesno != 1 ? '' : 'disabled')}>
                  <a class="page-link" aria-label="Previous">
                    <i class="fas fa-chevron-left"></i>
                    <span class="sr-only"><i class="fas fa-angle-double-left"></i></span>
                  </a>
                </li>

                {quizData.map((item, index) => {
                  var cls = "btn btn-white-bordered ";
                  if (isSelectedAnswer(item)) {
                    cls += "btn-white-bordered-green";
                  } else if (
                    (checkLocalstorageKeys(item) === 0 && index !== 0) || isAssessmentReview
                  ) {
                    cls += "btn-white-bordered-orange";
                  } else if (
                    index === 0 || (!isSelectedAnswer(item) && checkLocalstorageKeys(item) !== 0)
                  ) {
                    cls += "btn-white-bordered-red";
                  }
                  cls = cls + ` ${quesno - 1 == index ? 'active' : ''} ${isShowing(index)}`
                  return (
                    <li
                      ref={currentQuestion}
                      key={index}
                      class={cls}
                      onClick={() => {
                        if (isRefClick && !isAssessmentReview) {
                          setIsRefClick(false);
                          handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid]);
                        }else if (!isAssessmentReview) {
                          handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid]);
                          setquesno(index + 1);
                          localStorage.setItem(
                            `@qa${Array.isArray(item) ? item[0].qid : item.qid}qa`,
                            parseInt(localStorage.getItem(`@qa${(Array.isArray(item) ? item[0].qid : item.qid)}qa`) || 0) + 1
                          );
                          setquestion(Array.isArray(item) ? item[0].qid : item.qid);
                          handleQuestion(Array.isArray(item) ? item[0].qid : item.qid);
                        } else {
                          setquesno(index + 1);
                          setquestion(Array.isArray(item) ? item[0].qid : item.qid);
                          handleQuestion(Array.isArray(item) ? item[0].qid : item.qid);

                        }
                      }}>
                      <a class="page-link">{index + 1}</a>
                    </li>
                  );
                })}

              {signaturePage ? <li
                className={`btn btn-white-bordered ${quesno == quizData.length + 1 ? 'active' : ''
                      } ${isGreen
                        ? 'btn-white-bordered-green'
                        : sigVisited
                          ? 'btn-white-bordered-red'
                          : 'btn-white-bordered-orange'
                      } ${isShowing(quizData.length)}`}
                onClick={() => {
                  setquesno(quizData.length + 1);
                  handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid])
                }}>
                <a class="page-link">{quizData.length + 1}</a>
              </li> : null}
                <li
                  class={"page-item action-pagination next-step-link" + ((signaturePage ? quesno == quizData.length + 1 : quesno == quizData.length) ? ' disabled' : '')}
                  onClick={() => {  isAssessmentReview ? handleReviewQuest('next') : handleNav('next') }}
                >
                  <a class="page-link " aria-label="Next">
                    <i class="fas fa-chevron-right"></i>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
                <li
                  class={"page-item action-pagination" + ((signaturePage ? quesno == quizData.length + 1 : quesno == quizData.length) ? ' disabled' : '')}
                  onClick={() => {  isAssessmentReview ? handleReviewQuest('last') : handleNav('last') }}
                >
                  <a class="page-link next-page-link"><i class={"fas fa-angle-double-right"}></i></a>
                </li>
              </ul>

              <div class="quiz-footer-btns ">
                {(signaturePage ? quizData.length + 1 != quesno : quizData.length != quesno) ? (
                  <a
                  onClick={() => {
                    if (!isAssessmentReview) {
                      const val = keys.indexOf(`qa${question.toString()}qa`);
                      localStorage.setItem(
                        `@${keys[val + 1]}`,
                        parseInt(localStorage.getItem(`@${keys[val + 1]}`) || 0) +
                        1
                      );
                      setquestion(keys[val + 1]?.replaceAll("qa", ""));
                      setquesno(val + 2);
                      handleQuestion(keys[val + 1]?.replaceAll("qa", ""));
              
                      handleSaveAndNext(Array.isArray(quizData[quesno-1]) ? quizData[quesno-1].map(d => d.qid) : [quizData[quesno-1]?.qid]);
                    } else {
                      const val = keys.indexOf(`qa${question.toString()}qa`);
                      setquestion(keys[val + 1]?.replaceAll("qa", ""));
                      setquesno(val + 2);
                      handleQuestion(keys[val + 1]?.replaceAll("qa", ""));
                    }
                  }}
                    class="btn btn-white-bordered btn-primary"
                  >
                    {isAssessmentReview ? 'View Next' : 'Save and Next'}
                    <i class="fal ml-1 fa-chevron-right"></i>
                  </a>
                ) : !isAssessmentReview ? (
                  <button
                    onClick={() => {
                      handleSubmit('unanswerStatus')
                    }}
                    className={"btn btn-primary check-btn "}
                    disabled={submitLoading === true || (signaturePage && !isValidSignature)}
                  >
                    <i className={submitLoading==true ? "fas fa-cog fa-spin" : "fas fa-check"}></i>
                    Set to Final
                  </button>
                ) : null}
              </div>
            </div>
            )  : 
            (
              <div className="pagination-btn-group d-flex justify-content-end mt-4 mb-4">

              <button
              onClick={() => {
                console.log("clicked")
                props.setCanBeSTF(true)
              }}
              className={"btn btn-primary check-btn "}
              disabled={submitLoading === true || (signaturePage && !isValidSignature)}
              >
            <i className={submitLoading==true ? "fas fa-cog fa-spin" : "fas fa-check"}></i>
            Submit
          </button>
              </div>
          )
          }
          </div>
        </>
    </div>
  );
}

export default React.memo(ViewQuestion)